<!-- 时间弹出框 -->
<template>
    <div style="height: 400px">
        <div class="timer-ctn">
            <div>时间区间：</div>
            <el-date-picker
                v-model="dateTimes"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="handleChange"
            ></el-date-picker>
            <el-button size="small" class="btn-primary" style="margin-left: 10px" @click="submitTimer">确定</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    props: ['start', 'end'],
    data() {
        return {
            dateTimes: [],
            timer: {
                start: '',
                end: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created() {},
    mounted() {
        this.timer = {
            start: this.start,
            end: this.end
        };
        this.dateTimes.push(this.start);
        this.dateTimes.push(this.end);
    },
    methods: {
        submitTimer() {
            this.$emit('timerSearch', this.timer);
        },
        handleChange(val) {
            if (val) {
                this.timer = {
                    start: val[0] + ' 00:00:00',
                    end: val[1] + ' 23:59:59'
                };
            } else {
                this.timer = {
                    start: '',
                    end: ''
                };
            }
        }
    }
};
</script>
<style lang="less" scoped>
.timer-ctn {
    display: flex;
    align-items: center;

}
</style>